// node modules
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';

// app modules: components
import AlacarteStatusIndicator from 'components/AlacarteStatusIndicator';
import BookRankOverlay from 'components/BookRankOverlay';
import Link from 'components/Link';
import Image from 'components/Image';

// app modules: services
import assets from 'services/assets';
import route from 'services/route';

// assets
import CssThumbnailItem from './ThumbnailItem.scss';

function SearchBookItem(props) {
  const { item, onClick } = props;

  useStyles(CssThumbnailItem);

  return (
    <div className="search-thumbnail-item">
      {item.is_alacarte ? (
        <AlacarteStatusIndicator
          available={item.alacarte_available}
          isbn={item.isbn}
          signature_={item.signature_}
          className="search-thumbnail-item__alacarte"
        />
      ) : null}
      <Link to={route.book(item.isbn, item.signature_)} onClick={onClick}>
        <Image
          overlay={
            item.is_alacarte ? null : <BookRankOverlay ranking={item.ranking_recommendations} />
          }
          ranking={item.is_alacarte ? null : item.ranking_recommendations}
          image={assets.coverUrl(item.image_name, {
            resize: 'fit-in',
            width: 230,
            height: 230,
          })}
          height={115}
          alt={item.title}
        />
      </Link>
    </div>
  );
}

SearchBookItem.propTypes = {
  item: PropTypes.shape({
    image_name: PropTypes.string,
    isbn: PropTypes.string,
    signature_: PropTypes.string,
    ranking_recommendations: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func,
};

SearchBookItem.defaultProps = {
  onClick: () => {},
};

export default SearchBookItem;
